import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Introduction() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={5}
            xl={5}
            xxl={5}
            className="my-auto text-center order-md-1 order-2"
          >
            <StaticImage
              src="../../../images/case-studies/kush-me/tek_img_01.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={550}
              height={488}
            />
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto  offset-lg-1 order-md-2 order-1"
          >
            <h2>
              The <span style={{ color: "#49A950" }}>Introduction</span>
            </h2>
            <p>
              It doesn’t matter where you are, Kush Me locates a marijuana
              dispensary nearest to your location. The strong user-orientated
              functionality is what makes Kush Me stand out, as an easy-to-use
              application.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Introduction;
